import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Procedures from "@/components/site/Procedures";
import Space from "@/components/site/Space";
import Testimonials from "@/components/site/Testimonials";
import Location from "@/components/site/Location";
import Footer from "@/components/site/Footer";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";
import { Toaster } from "@/components/ui/sonner";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-white text-black">
      <Header />
      <Hero />
      <Marquee />
      <About />
      <Procedures />
      <Space />
      <Testimonials />
      <Location />
      <Footer />
      <FloatingWhatsApp />
      <Toaster position="top-center" richColors />
    </main>
  );
}
